import { render, staticRenderFns } from "./InstallationsList.vue?vue&type=template&id=3cb640bd&"
import script from "./InstallationsList.vue?vue&type=script&lang=js&"
export * from "./InstallationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb640bd')) {
      api.createRecord('3cb640bd', component.options)
    } else {
      api.reload('3cb640bd', component.options)
    }
    module.hot.accept("./InstallationsList.vue?vue&type=template&id=3cb640bd&", function () {
      api.rerender('3cb640bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/InstallationsList.vue"
export default component.exports